import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { EaccessAuthService } from '../auth/eaccess-auth.service';
import { NGXLogger } from 'ngx-logger';
import { ROLE_TDRATES_WRITE } from '../shared/constants';
import { map } from 'rxjs';

export const canWriteTdRatesGuard: CanActivateFn = (route, state) => {
  const authService = inject(EaccessAuthService);
  const router = inject(Router);
  const logger = inject(NGXLogger);

  return authService.hasRole$(ROLE_TDRATES_WRITE).pipe(
    map((hasRole) => {
      if (hasRole) {
        return true;
      } else {
        logger.log('User is not authorized to write TD rates. Redirecting to landing page.');

        const path = state.url.split('?')[0];
        const queryParams = router.parseUrl(state.url.replace(path, '')).queryParams;

        const url = router.parseUrl(`/?origin=${path}`);

        for (const kvp of Object.entries(queryParams)) {
          if (kvp[0] !== 'origin') {
            url.queryParams[kvp[0]] = kvp[1];
          }
        }

        return url;
      }
    })
  );
};
